import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LanguageCode } from '../language.model';
import { TranslationsService } from '../translations.service';

@Component({
  selector: 'csi-language-dropdown-select',
  templateUrl: './language-dropdown-select.component.html',
  styleUrls: ['./language-dropdown-select.component.scss']
})
export class LanguageDropdownSelectComponent implements OnInit {
  availableLanguages = [
    { id: 'en', label: 'English', flag: 'canada_flag' },
    { id: 'fr', label: 'Français', flag: 'france_flag' },
    { id: 'fr-qc', label: 'Français (QC)', flag: 'quebec_flag' },
    { id: 'es', label: 'Español', flag: 'spain_flag' },
    { id: 'es-sa', label: 'Español (SA)', flag: 'chile_flag' }
  ];

  constructor(
    public translocoService: TranslocoService,
    public translocoLocalService: TranslationsService
  ) {}

  ngOnInit() {}

  get activeLang(): string {
    return this.translocoService.getActiveLang();
  }

  get activeLanguageLabel(): string {
    const lang = this.availableLanguages.find(l => l.id === this.translocoService.getActiveLang());
    return lang ? lang.label : 'Select Language';
  }

  get activeLanguageFlag(): string {
    const lang = this.availableLanguages.find(l => l.id === this.translocoService.getActiveLang());
    return lang ? lang.flag : 'canada_flag';
  }

  isActiveLanguage(langId: string): boolean {
    return this.translocoService.getActiveLang() === langId;
  }

  changeLanguage(lang: string) {
    this.translocoService.setActiveLang(lang);
    this.translocoLocalService.changeLanguage(LanguageCode[lang]);
  }
}
